import http from '@/services/http';

/**
 * ABM de credenciales de integraciones por tenant (#351) — el ".env por cliente".
 * Backend: bisstrack_backend/src/modules/integraciones. JWT de tenant (no admin).
 */
export default {
  obtenerConfig(filtros = {}) {
    return http.get('integraciones/config', { params: filtros });
  },

  guardarCredencial(proveedor, perfil, clave, datos) {
    return http.put(`integraciones/config/${proveedor}/${perfil}/${clave}`, datos);
  },

  eliminarCredencial(proveedor, perfil, clave) {
    return http.delete(`integraciones/config/${proveedor}/${perfil}/${clave}`);
  },

  probarConexion(proveedor, perfil) {
    return http.post(`integraciones/config/${proveedor}/${perfil}/probar`);
  },
};
